/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type UpdateOrgRateLimitAuthOrgsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class UpdateOrgRateLimitAuthOrgsResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgRateLimitAuthOrgsResponse429ResponseBodyData;

  constructor(
    err: UpdateOrgRateLimitAuthOrgsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgRateLimitAuthOrgsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type UpdateOrgRateLimitAuthOrgsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class UpdateOrgRateLimitAuthOrgsResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgRateLimitAuthOrgsResponse409ResponseBodyData;

  constructor(
    err: UpdateOrgRateLimitAuthOrgsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgRateLimitAuthOrgsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type UpdateOrgRateLimitAuthOrgsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class UpdateOrgRateLimitAuthOrgsResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgRateLimitAuthOrgsResponse404ResponseBodyData;

  constructor(
    err: UpdateOrgRateLimitAuthOrgsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgRateLimitAuthOrgsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type UpdateOrgRateLimitAuthOrgsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class UpdateOrgRateLimitAuthOrgsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgRateLimitAuthOrgsResponseResponseBodyData;

  constructor(
    err: UpdateOrgRateLimitAuthOrgsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgRateLimitAuthOrgsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type UpdateOrgRateLimitAuthOrgsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class UpdateOrgRateLimitAuthOrgsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgRateLimitAuthOrgsResponseBodyData;

  constructor(
    err: UpdateOrgRateLimitAuthOrgsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgRateLimitAuthOrgsResponseBody";
  }
}

/**
 * Bad request
 */
export type UpdateOrgRateLimitResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class UpdateOrgRateLimitResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateOrgRateLimitResponseBodyData;

  constructor(
    err: UpdateOrgRateLimitResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateOrgRateLimitResponseBody";
  }
}

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    UpdateOrgRateLimitAuthOrgsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateOrgRateLimitAuthOrgsResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateOrgRateLimitAuthOrgsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    UpdateOrgRateLimitAuthOrgsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateOrgRateLimitAuthOrgsResponse429ResponseBody
  > = z.instanceof(UpdateOrgRateLimitAuthOrgsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    UpdateOrgRateLimitAuthOrgsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateOrgRateLimitAuthOrgsResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateOrgRateLimitAuthOrgsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    UpdateOrgRateLimitAuthOrgsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateOrgRateLimitAuthOrgsResponse409ResponseBody
  > = z.instanceof(UpdateOrgRateLimitAuthOrgsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    UpdateOrgRateLimitAuthOrgsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateOrgRateLimitAuthOrgsResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateOrgRateLimitAuthOrgsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    UpdateOrgRateLimitAuthOrgsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateOrgRateLimitAuthOrgsResponse404ResponseBody
  > = z.instanceof(UpdateOrgRateLimitAuthOrgsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponseResponseBody$inboundSchema:
  z.ZodType<
    UpdateOrgRateLimitAuthOrgsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateOrgRateLimitAuthOrgsResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateOrgRateLimitAuthOrgsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponseResponseBody$outboundSchema:
  z.ZodType<
    UpdateOrgRateLimitAuthOrgsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateOrgRateLimitAuthOrgsResponseResponseBody
  > = z.instanceof(UpdateOrgRateLimitAuthOrgsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponseBody$inboundSchema: z.ZodType<
  UpdateOrgRateLimitAuthOrgsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateOrgRateLimitAuthOrgsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateOrgRateLimitAuthOrgsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgRateLimitAuthOrgsResponseBody$outboundSchema: z.ZodType<
  UpdateOrgRateLimitAuthOrgsResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateOrgRateLimitAuthOrgsResponseBody
> = z.instanceof(UpdateOrgRateLimitAuthOrgsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const UpdateOrgRateLimitResponseBody$inboundSchema: z.ZodType<
  UpdateOrgRateLimitResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateOrgRateLimitResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateOrgRateLimitResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateOrgRateLimitResponseBody$outboundSchema: z.ZodType<
  UpdateOrgRateLimitResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateOrgRateLimitResponseBody
> = z.instanceof(UpdateOrgRateLimitResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
